import { getItemHighlight } from "./utils";

export function getReturnCaseTemplate(item, html) {
  return html` <div class="aa-ItemWrapper">
    <div class="aa-ItemContent">
      <div class="aa-ItemIcon aa-ItemIcon--alignTop">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="laptop-mobile"
          class="svg-inline--fa fa-laptop-mobile "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          height="24"
          width="24"
        >
          <path
            fill="currentColor"
            d="M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
          />
        </svg>
      </div>
      <div class="aa-ItemContentBody">
        <div class="aa-ItemContentTitle">
          ${getItemHighlight(
            html,
            item,
            "return_case.stocklist_item.name",
            "Return case"
          )}
          <span class="gsid text-success">ID: ${item.document.id}</span>
        </div>
        <div class="aa-ItemContentDescription">
          <span>Status: ${item.document["return_case.status"]}</span>
          <span class="orgid label label-default"
            >Org ID: ${item.document["return_case.organisation_id"]}</span
          >
          <span class="text-danger ml-1">
            (${item.document["return_case.organisation.name"]})</span
          >
        </div>
      </div>
    </div>
  </div>`;
}
